const Drop = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 81.96 122.88"
		{...props}
	>
		<path
			d="M40.95 0c2.64 11.28 5.67 20.29 9.04 26.98 3.37 6.69 8.53 13.94 15.45 21.76l2.98 3.32c9.04 10.06 13.55 20.15 13.55 30.21 0 11.14-4.02 20.69-12.07 28.65-8.08 7.96-17.71 11.96-28.93 11.96-11.19 0-20.8-4-28.88-11.96C4.03 102.96 0 93.41 0 82.27c0-10.06 4.51-20.15 13.55-30.21l2.98-3.32c6.91-7.82 12.07-15.07 15.45-21.76 3.36-6.69 6.37-15.7 8.97-26.98zM13.81 76.29c-.21-2.28 1.48-4.3 3.76-4.51a4.145 4.145 0 0 1 4.51 3.76c.52 5.52 1.73 10.61 4.04 15 2.23 4.24 5.55 7.89 10.35 10.7a4.15 4.15 0 0 1 1.48 5.68 4.15 4.15 0 0 1-5.68 1.48c-6.25-3.66-10.58-8.42-13.51-13.99-2.85-5.42-4.33-11.55-4.95-18.12z"
			style={{
				fillRule: 'evenodd',
				clipRule: 'evenodd',
			}}
		/>
	</svg>
);
export default Drop;
